 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Claim
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryClmFilterForm">
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            v-model="filtersClm.clmNo"
                            :label="filtersClmLabel.clmNo"
                            :error-messages="errors.collect('filterClm.clmNo')"
                            data-vv-name="filterClm.clmNo"
                            :data-vv-as="filtersClmLabel.clmNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            v-model="filtersClm.polNo"
                            :label="filtersClmLabel.polNo"
                            :error-messages="errors.collect('filterClm.polNo')"
                            data-vv-name="filterClm.polNo"
                            :data-vv-as="filtersClmLabel.polNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearClmFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doClmFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="clmHeaders"
          :items="clmItems"
          v-bind:options.sync="paginationClm"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsClm"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.clmNo }}</td>
              <td>{{ row.item.polNo }}</td>
              <td style="text-align: center">
                <v-btn icon color="primary" text type="submit" @click="assignClmNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      clmItems: [],
      totalItemsClm: 0,
      filtersClmLabel: {
        clmNo: 'Claim No.',
        polNo: 'Policy No.'
      },
      filtersClm: {
        clmNo: undefined,
        polNo: undefined
      },
      clmHeaders: [
        { text: 'Claim No.', align: 'left', value: 'clmNo' },
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationClm: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      panel: [0]
    }
  },
  mounted() {
    this.doClearClmFilters()
  },
  watch: {
    paginationClm: function (value) {
      this.fetchClmData()
    }
  },
  methods: {
    doFilterOnEnter() {
      this.doClmFilters()
    },
    closeDialog() {
      this.filtersClm.clmNo = undefined
      this.filtersClm.polNo = undefined
      this.$emit('close')
    },
    doClearClmFilters() {
      this.filtersClm.clmNo = undefined
      this.filtersClm.polNo = undefined
      this.fetchClmData()
    },
    doClmFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryClmFilterForm').then((result) => {
        if (result) {
          this.paginationClm.page = 1
          this.fetchClmData()
        }
      })
    },
    async fetchClmData() {
      const apiUrl = this.apiURI
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationClm
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.filtersClm)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), messageFilters, this.paginationClm.sortBy, this.paginationClm.sortDesc)
          )
          if (result.data) {
            this.totalItemsClm = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'clmItems', data)
            } else {
              this.$set(this, 'clmItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignClmNo(data) {
      this.$emit('assign-claim', data)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    apiURI: String
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
